APP.MobileHeader = (/** @lends APP.Header */function () {
	'use strict';

	var exports = {},
		cache = {},
		remaining = [],
		$header,
		wholeMenuState,
		$wholeMenu,
		$wholeMenuToggler,
		$unFocusedElements,
		$currentMenu,
		currentLevel,
		nextLevel,
		previousLevel,
		$mobSegmentSelector,
		$mobSegmentToggler,
		segmentSelectorState,
		ajaxString,
		ajaxPageNr,
		$mobileMenuTPL,
		screenHeight,
		menuHeight,
		$body,
		firstCall = true;

	function init() {
		initDomElements();
		initBindings();
	}

	/**
	 * Init DOM Elements
	 *
	 * @inner
	 * @public
	 * @memberof App.MobileHeader
	 * @returns {void}
	 */
	function initDomElements() {
		$body = $(document.body);
		$header = $body.find('.header--mobile');
		$wholeMenu = $body.find('[data-whole-nav-active]');
		$wholeMenuToggler = $body.find('[data-click="whole-menu-toggle"]');
		$mobileMenuTPL = APP.Template.get('mobile-menu');
		$currentMenu = $body.find('[data-mob-nav="active"]');
		currentLevel = 6;
		screenHeight = $(window).height() - 70;
		$wholeMenu.css('min-height', screenHeight);
	}

	function initBindings() {
		upDateWholeMenuState();
		updateServiceUrl();
		initBaseMenu();

		APP.Bind.click({
			'whole-menu-toggle': initToggleWholeMenu,
			'switch-menu-forward': initMenuForward,
			'switch-menu-back': initMenuBack,
			'toggle-mobile-segment': mobileSegmentToggle
		});

		$body.on('click', function (e) {
			tapOutClose(e);
		});
	}

	function menuSize() {
		menuHeight = $currentMenu.innerHeight() + 50;
		if (menuHeight > screenHeight) {
			$wholeMenu.css('min-height', menuHeight);
		}
	}

	function initToggleWholeMenu() {

		if (wholeMenuState === 'false') {
			$header.addClass('menu-open');
			$wholeMenu.attr('data-whole-nav-active', 'true');
			$wholeMenuToggler.attr('data-active-state', 'true');
		} else {
			$wholeMenu.attr('data-whole-nav-active', 'false');
			$wholeMenuToggler.attr('data-active-state', 'false');
			setTimeout(function(){
				$header.removeClass('menu-open');
			}, 300);
		}
		upDateWholeMenuState();
	}

	function mobileSegmentToggle() {
		if (segmentSelectorState === 'false') {
			$mobSegmentSelector.attr('data-mob-segment-selector', 'true');
			$mobSegmentToggler.attr('data-active-state', 'true');
			$unFocusedElements.addClass('no-focus');
		} else {
			$mobSegmentSelector.attr('data-mob-segment-selector', 'false');
			$mobSegmentToggler.attr('data-active-state', 'false');
			$unFocusedElements.removeClass('no-focus');
		}
		upDateSegmentState();
	}

	function tapOutClose(e) {
		if (segmentSelectorState === 'true') {
			if (!containElement($mobSegmentToggler, e.target) && !containElement($mobSegmentSelector, e.target)) {
				mobileSegmentToggle();
			}
		}

		if (wholeMenuState === 'true') {
			if (!containElement($wholeMenuToggler, e.target) && !containElement($wholeMenu, e.target)) {
				initToggleWholeMenu();
			}
		}
	}

	function upDateWholeMenuState() {
		wholeMenuState = $wholeMenu.attr('data-whole-nav-active');
	}

	function upDateSegmentState() {
		$mobSegmentToggler = $body.find('[data-click="toggle-mobile-segment"]');
		$mobSegmentSelector = $body.find('[data-mob-segment-selector]');
		$unFocusedElements = $mobSegmentSelector.parent().siblings();
		segmentSelectorState = $mobSegmentSelector.attr('data-mob-segment-selector');
	}

	function containElement($wrapper, $element) {
		return $wrapper.is($element) || $wrapper.has($element).length > 0;
	}

	function updateServiceUrl() {
		ajaxString = $wholeMenu.attr('data-call-init');
		ajaxPageNr = ajaxString.split('current=');
	}

	function initBaseMenu() {
		displayMenuLevel(ajaxPageNr, currentLevel);
	}

	function displayMenuLevel(id, level) {
		return loadMenuLevel(id).then(function (menuObject) {
			goToLevel(level).html($mobileMenuTPL(menuObject));
			upDateSegmentState();
			menuSize();
			APP.Layout.checkInstallments();
		});
	}

	function loadMenuLevel(id) {
		return new Promise(function (resolve) {
			if (cache.hasOwnProperty(id)) {
				resolve(cache[id]);
			} else {
				addToRemaining(id);
				loadRemaining(id).then(function (id) {
					resolve(cache[id]);
				});
			}
		});
	}


	function goToLevel(level) {
		var $nextMenu = $body.find('[data-nav-level=' + level + ']');

		$currentMenu.attr('data-mob-nav', level >= currentLevel ? 'wasactive' : 'inactive');
		$nextMenu.attr('data-mob-nav', 'active');
		currentLevel = parseInt(level, 10);
		return $nextMenu;
	}

	function initMenuForward(event, id) {
		nextLevel = currentLevel + 1;
		updateNavData();
		displayMenuLevel(id, nextLevel);
	}

	function initMenuBack(event, id) {
		previousLevel = currentLevel - 1;
		updateNavData();
		displayMenuLevel(id, previousLevel);
	}

	function updateNavData() {
		$currentMenu = $body.find('[data-mob-nav="active"]');
	}

	function loadRemaining(loadId) {
		var queryString = '&id[]=' + remaining.join('&id[]=');

		if (remaining.length === 0 || firstCall) {
			queryString = '';
		}


		return new Promise(function (resolve) {
			APP.Service.get({}, ajaxString + queryString).then(function (response) {
				var resultId;

				remaining = [];
				resultId = addCache(response.data);
				if (firstCall) {
					resolve(resultId);
				} else {
					resolve(loadId);
				}
				firstCall = false;
			});
		});
	}

	function collectActualIds(responseData) {
		var index;

		if (responseData.back) {
			addToRemaining(responseData.back.id);
		}

		for (index in responseData.current) {
			if (responseData.current.hasOwnProperty(index)) {
				if (responseData.current[index].hasChildren) {
					addToRemaining(responseData.current[index].id);
				}
			}
		}

	}

	function addCache(responseData) {
		var id;

		for (id in responseData) {
			if (responseData.hasOwnProperty(id)) {
				collectActualIds(responseData[id]);
				cache[id] = responseData[id];
				remaining.remove(id);
			}
		}

		return id;
	}

	function addToRemaining(id) {
		if (!cache.hasOwnProperty(id)) {
			remaining.push(id);
		}

	}

	exports.init = init;
	return exports;

}());

